<template>
  <popper
    class="custom-popper"
    :append-to-body="true"
    trigger="hover"
    :delay-on-mouse-over="800"
    :delay-on-mouse-out="100"
    :options="{
      placement: positionPreview,
      modifiers: { offset: [0,10] },
    }"
  >
      <!-- modifiers: { offset: { offset: '0,10px' } }, -->
    <div class="popper card-preview" id="card-preview">
      <div
        class="flex-full email-header d-theme-dark-bg"
        style="padding: 10px 10px 0px 10px; max-width: 400px; max-height: 500px"
      >
        <div class="w-full">
          <div class="item-details">
            <div class="flex justify-between flex-wrap">
              
                <p class="chapeu-details-mosaic font-bold chapeu cursor-pointer" @click.stop="$emit('open-detail')">{{ hatName }}</p>
              
              <!-- <template v-if="!isAuthenticated">
                <span class="item-date" v-if="!isItemNews">{{
                  formatDate(data.dt_publish, { dateStyle: "short" })
                }}</span>
                <span class="item-date" v-if="isItemNews">{{
                  data.dt_publish | moment("from")
                }}</span>
              </template>
              <template v-else>
                <span class="item-date" v-if="!isItemNews">{{
                  formatDate(data.dt_report, { dateStyle: "short" })
                }}</span>
                <span class="item-date" v-if="isItemNews">{{
                  data.data_object | moment("from")
                }}</span>
              </template> -->
            </div>
            <!-- <div class="card-chips">
              <vs-chip
                class="cursor-pointer filter-chip important-chip"
                v-if="isImportant"
                >{{ $t("BADGES").Important }}</vs-chip
              >
              <vs-chip
                class="cursor-pointer filter-chip exclusive-chip"
                v-if="data.exclusive"
                >{{ $t("BADGES").Exclusive }}</vs-chip
              >
            </div> -->
            <span class="title-details-mosaic item-chapeu font-semibold view cursor-pointer" @click.stop="$emit('open-detail')">{{ getTitle }}</span>
          </div>
          <!-- <VuePerfectScrollbar class="scroll-area md:px-4 pt-4 px-1" :settings="settings"> -->
          <vs-divider
            v-if="data.content.abstract.data"
            class="m-1"
          ></vs-divider>
          <div
            v-if="data.content.abstract.data"
            class="abstract-title"
            :class="{
              '': data.content.abstract.data,
            }"
            @click.stop="$emit('open-detail')"
          >
            {{ data.content.abstract.data }}
          </div>
          <vs-divider v-if="data.content.body.data" class="m-1"></vs-divider>
          <div
            class="abstract-title popover-preview-content cursor-pointer"
            v-if="data.content.body.data"
            v-html="data.content.body.data"
            @click.stop="$emit('open-detail')"
          ></div>
          <!-- </VuePerfectScrollbar> -->
        </div>
        <!-- <div
          class="cursor-pointer display-detaiil"
          @click.stop="$emit('open-detail')"
        >
          <span>
            <p class="text-primary">{{ $t('MULTIMEDIA').Details}}</p>
          </span>
        </div> -->
      </div>
    </div>
    <span class="card-icons-wrap preview-content" :class="{'preview-reference-component': !iconReferencePreview && !isMarqueePreview}" slot="reference">
      <feather-icon
        v-if="iconReferencePreview"
        icon="EyeIcon"
      />
    </span>
  </popper>
</template>

<script>
import { CONTENT } from '../../../enums/enum-content';
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import translateFieldHelper from '../../../helpers/translate-field-helper';
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    // isAuthenticated: {
    //   required: true,
    // },
    // isItemNews: {
    //   type: Boolean,
    //   required: true,
    // },
    iconReferencePreview: {
      type: Boolean,
      default: true
    },
    positionPreview: {
      type: String,
      default: 'right'
    },
    isMarqueePreview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getTitle() {
      if (!this.data) return '';
      if (this.data.newsContent[0].code == CONTENT.STATISTIC ||
        this.data.newsContent[0].code == CONTENT.EXPORTS ||
        this.data.newsContent[0].code == CONTENT.INFORMATIVE) {
          return translateFieldHelper.getTranslateField('name', this.data.reportType);
        }
      return this.data.content.title.data;
    },
    hatName() {
      if (this.data.hat[0]) {
        return this.data.hat[0].name.toUpperCase();
      }
      return this.data.newsContent[0][`name${this.$i18n.locale}`];
    },
    isImportant() {
      return this.data.importance > 0;
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-4 w-4";
      } else {
        return "h-6 w-6";
      }
    },
  }, 
  methods: {
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
  },
  components: {
    popper: Popper,
  }
};
</script>

<style lang="scss">
  .preview-reference-component {
    height: 100% !important;
    width: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
  }
  .from-marquee {
    height: 100% !important;
    width: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>